import Producent from "../../model/producent";
import DataModel from "../../scripts/dataModel"

export async function getAll(): Promise<Producent[]> {
    const promise = new Promise<Producent[]> ((resolve, reject) => {
        resolve(DataModel.getInstance().producenter)
    })

    return promise
}

export async function getById(idParameter: string): Promise<Producent | undefined> {
    const promise = new Promise<Producent | undefined>((resolve, reject) => {
        const filtered = DataModel.getInstance().producenter.filter((p) => {
            return p.dbId === idParameter
        })
        if (filtered.length > 0)
            resolve(filtered[0])
        else
            resolve(undefined)
    })
    return promise
}